export default function tabsService() {
  return function generate(viewField, engineApi) {
    // 1 - ejecutamos el padre tipo "tabs"
    const element = engineApi.register.setCommonAttributes('ec-tabs', viewField, engineApi);

    // 2 - transformamos los hijos tipo "tab" en tipo "object"
    viewField.properties.forEach(v => (v.type = 'object'));

    // 3 - ejecutamos los hijos (los "tab") -> despues del padre para que tengan el parent relleno, importante para disabled por ejemplo
    const tabs = engineApi.handleProperties(viewField, engineApi);

    // 4 - añadimos el html de las pestañas
    element.setHtml(
      viewField.properties
        .map(
          (tab, i) => `
        <section label="${tab.title || ''}">${tabs[i].toString()}
        </section>`
        )
        .join('')
    );

    return element;
  };
}
